import React, { ReactNode } from 'react';

type Props = {
  defaultValue: boolean;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children: (arg0: boolean, arg1: (...args: Array<any>) => any) => ReactNode;
};
type State = {
  toggled: boolean;
};
export default class ToggleHelperContainer extends React.Component<
  Props,
  State
> {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/static-property-placement
  static defaultProps = {
    // eslint-disable-next-line react/default-props-match-prop-types
    defaultValue: false,
  };

  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/state-in-constructor
  state = {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    toggled: this.props.defaultValue,
  };

  render() {
    // eslint-disable-next-line react/prop-types, react/destructuring-assignment
    return this.props.children(this.state.toggled, (setToggle) =>
      this.setState((prevState) => {
        const toggled =
          typeof setToggle === 'boolean' ? setToggle : !prevState.toggled;
        return {
          toggled,
        };
      })
    );
  }
}
